module.exports={
  "name": "js-conflux-sdk",
  "description": "JavaScript Conflux Software Development Kit",
  "version": "2.4.10",
  "license": "LGPL-3.0",
  "author": "pan.wang@confluxnetwork.org",
  "repository": "https://github.com/Conflux-Chain/js-conflux-sdk.git",
  "keywords": [
    "conflux",
    "sdk"
  ],
  "main": "src/index.js",
  "bin": {
    "cfxjs": "bin/cfxjs.js",
    "sponsor": "bin/sponsor.js",
    "rpc": "bin/rpc.js"
  },
  "types": "./dist/types/index.d.ts",
  "browser": "dist/js-conflux-sdk.umd.min.js",
  "browserify-browser": {
    "secp256k1": "secp256k1/elliptic",
    "./src/util/jsbi": "jsbi"
  },
  "files": [
    "dist",
    "mock",
    "src"
  ],
  "scripts": {
    "eslint": "npx eslint ./src ./test ./mock",
    "build": "node scripts/build-frontend.js && npm run gendts",
    "gendts": "npx tsc && node scripts/deal-dts.js",
    "document": "node scripts/document.js",
    "jsdocToMd": "node scripts/jsdoc-to-md.js",
    "jsdoc": "jsdoc -c jsdoc.json",
    "prepublishOnly": "npm run build",
    "test": "jest --coverage",
    "react": "npm run build & cd react & yarn build & yarn start"
  },
  "browserslit": "cover 99.5%",
  "dependencies": {
    "@conflux-dev/conflux-address-js": "1.3.16",
    "abi-util-lite": "^0.1.0",
    "big.js": "^5.2.2",
    "commander": "^8.0.0",
    "keccak": "^2.0.0",
    "lodash": "^4.17.21",
    "rlp": "^2.2.7",
    "scrypt-js": "^3.0.1",
    "secp256k1": "^3.7.1",
    "superagent": "^6.1.0",
    "websocket": "^1.0.35"
  },
  "devDependencies": {
    "@conflux-dev/jsonrpc-spec": "^0.2.1",
    "@babel/core": "^7.8.4",
    "@babel/plugin-transform-runtime": "^7.8.3",
    "@babel/preset-env": "^7.8.4",
    "@babel/runtime": "^7.8.4",
    "@conflux-dev/jsdoc-tsimport-plugin": "^1.0.5",
    "@geekberry/jsdoc-to-md": "0.0.8",
    "@types/node": "^14.0.23",
    "babel-plugin-lodash": "^3.3.4",
    "babelify": "^10.0.0",
    "browserify": "^16.5.1",
    "concurrently": "^5.1.0",
    "eslint": "^7.12.0",
    "eslint-config-airbnb-base": "^14.0.0",
    "eslint-plugin-import": "^2.18.2",
    "exorcist": "^1.0.1",
    "fs-extra": "^8.1.0",
    "jest": "26.6.0",
    "jsbi": "^3.1.4",
    "jsdoc-to-markdown": "^7.1.0",
    "jsdoc-tsimport-plugin": "^1.0.5",
    "minify-stream": "^2.0.1",
    "mold-source-map": "^0.4.0",
    "solc": "^0.6.10",
    "tidy-jsdoc": "^1.4.1",
    "typescript": "^4.6.4"
  },
  "resolutions": {
    "tinyify/acorn-node/acorn": "7.1.1",
    "eslint/espree/acorn": "7.1.1",
    "tinyify/unassertify/unassert/acorn": "7.1.1",
    "**/minimist": "^1.2.3",
    "**/kind-of": "^6.0.3",
    "**/elliptic": "^6.5.3",
    "**/lodash": "^4.17.20",
    "**/babel-jest": "^26.6.0",
    "jest/jest-cli/jest-config/jest-environment-jsdom/jsdom/acorn-globals/acorn": "6.4.1"
  }
}
